import Helper from "@ember/component/helper";

export default class FileTypeFromMimeType extends Helper {
  override compute([mimeType]: [string]) {
    const extensionFromMimeType = new Map([
      ["image/png", "image"],
      ["image/bmp", "image"],
      ["image/gif", "image"],
      ["image/jpeg", "image"],
      ["image/tiff", "image"],
      ["application/pdf", "PDF"]
    ]);
    return extensionFromMimeType.get(mimeType);
  }
}
